import type { PublicCatalogService } from "../schemas/booking.schemas";

/**
 * The lowest price among some services, as the server wrote it ("450.00"), for a "from ₹450" line;
 * null when there are none. Prices are only compared here, never added: amounts stay strings and are
 * shown with the money formatter.
 */
export function cheapest(services: readonly PublicCatalogService[]): string | null {
  let lowest: string | null = null;
  for (const { price } of services) {
    if (lowest === null || Number(price) < Number(lowest)) lowest = price;
  }
  return lowest;
}
